export const fillZero = (str: string, excptedLength: number = 2): string => {
  str = `${str}`;
  if (str.length >= excptedLength) return str;
  let newStr = str;
  for (let i = str.length; i < excptedLength; i++) {
    newStr = "0" + str;
  }
  return newStr;
};
